import React from "react";
import { CheckboxDropdownItem } from "@sonder/ui/source/styled/fragments/CheckboxDropdownItem";
import { UserCardInDropdownItem } from "@sonder/ui/source/styled/fragments/UserCardInDropdownItem";

interface AssigneeFilterGroupItemProps {
  isChecked: boolean;
  onClick?(): void;
  user: User;
}

export const AssigneeFilterGroupItem = ({
  isChecked,
  onClick = () => undefined,
  user,
}: AssigneeFilterGroupItemProps) => {
  const { avatarUrl, name } = user;

  return (
    <CheckboxDropdownItem checked={isChecked} onClick={onClick}>
      <UserCardInDropdownItem imageUrl={avatarUrl} name={name} />
    </CheckboxDropdownItem>
  );
};
